module.exports = __webpack_public_path__ + "static/media/courier_logo.165a76e2.png";